// SPDX-License-Identifier: AGPL-3.0-or-later
import { indexResponseItems, projectSingleAnswer, walkQuestionnaireItems } from './answers.js';
/**
 * Completeness pass: PLAN.md §5 step 4. Every *active* `required: true`
 * item must have at least one non-empty answer. The field pass already
 * raises a per-item `required` error; the completeness pass emits a
 * single form-level `incomplete` finding summarising what is missing, so
 * the API and dashboard can show "3 required items unanswered" without
 * re-counting.
 */
export function runCompletenessPass(questionnaire, response, activeLinkIds) {
    const responseItems = indexResponseItems(response);
    const missing = [];
    for (const item of walkQuestionnaireItems(questionnaire.item)) {
        if (!activeLinkIds.has(item.linkId))
            continue;
        if (item.required !== true)
            continue;
        const r = responseItems.get(item.linkId);
        const hasAnswer = (r?.answer ?? []).some((a) => projectSingleAnswer(a) !== undefined);
        if (!hasAnswer)
            missing.push(item.linkId);
    }
    if (missing.length === 0)
        return [];
    return [
        {
            severity: 'error',
            code: 'incomplete',
            message: `${missing.length} required item(s) are not answered.`,
            // `n` mirrors the chrome dictionary's `finding.incomplete` arg
            // so the UI translator can substitute the count.
            context: { n: missing.length, missingLinkIds: missing },
            i18nKey: 'finding.incomplete',
        },
    ];
}
//# sourceMappingURL=completeness.js.map